import { get, post } from './api'

const ISSUE_PREFIX = '/blade-portal/issue'

export const issueService = {
  /**
   * 创建问题反馈
   */
  async createIssue(data) {
    const response = await post(`${ISSUE_PREFIX}/create`, {
      title: data.title,
      category: data.category,
      description: data.description,
      relatedBookingId: data.relatedBookingId,
    })
    return response
  },

  /**
   * 获取问题列表
   */
  async getIssues(params = {}) {
    const response = await get(`${ISSUE_PREFIX}/list`, {
      current: params.current || 1,
      size: params.size || 20,
      status: params.status,
      category: params.category,
    })
    return response
  },

  /**
   * 获取问题详情
   */
  async getIssueDetail(id) {
    const response = await get(`${ISSUE_PREFIX}/detail`, { id })
    return response
  },

  /**
   * 获取问题的沟通记录
   */
  async getIssueCommunications(id) {
    const response = await get(`${ISSUE_PREFIX}/communications`, { issueId: id })
    return response
  },

  /**
   * 添加问题回复
   */
  async addReply(issueId, message) {
    const response = await post(`${ISSUE_PREFIX}/reply`, {
      issueId,
      message,
    })
    return response
  },

  /**
   * 关闭工单
   */
  async closeIssue(id) {
    const response = await post(`${ISSUE_PREFIX}/close`, { id })
    return response
  },
}

export default issueService
